export default __webpack_public_path__ + "static/media/Inter-Regular.df2ccd63.woff";